import { lazy } from 'react';

// project imports
import Loadable from '../component/Loadable';
import SelectClinicPage from '../views/pages/Clinic';
import { AuthenticatedRoute, GuestOnlyRoute } from './AuthenticationGuard';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLogin3 = Loadable(
    lazy(() => import('views/pages/authentication/authentication3/Login3'))
);
const ForgetPassword = Loadable(
    lazy(() => import('views/pages/authentication/authentication3/forgetPassword'))
);
const ForgetPasswordSubmit = Loadable(
    lazy(() => import('views/pages/authentication/authentication3/ForgetPasswordSubmit'))
);

const ChangePassword = Loadable(
    lazy(() => import('views/pages/authentication/authentication3/changePassword'))
);

const Role = Loadable(lazy(() => import('views/pages/Role')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            element: <GuestOnlyRoute />,
            children: [
                {
                    path: '/login',
                    element: <AuthLogin3 />
                },
                {
                    path: '/forgetPassword',
                    children: [
                        {
                            path: 'changePassword',
                            element: <ForgetPasswordSubmit />
                        },
                        {
                            path: '',
                            element: <ForgetPassword />
                        }
                    ]
                },
                {
                    path: '/ChangePassword',
                    element: <ChangePassword />
                }
            ]
        },
        {
            element: <AuthenticatedRoute />,
            children: [
                {
                    path: '/role',
                    element: <Role />
                },
                {
                    path: '/select-clinics',
                    element: <SelectClinicPage />
                }
            ]
        }
    ]
};

export default AuthenticationRoutes;
